import { Form } from '@rocketseat/unform';
import {
  Breadcrumbs,
  Button,
  CanAccess,
  Dropdown,
  LogsFileErrorStorage,
  Modal,
  SearchBox,
  Text,
  Title,
  WrapperFlex,
} from '@unimed-fesp/components';
import format from 'date-fns/format';
import produce from 'immer';
import * as jwtDecode from 'jwt-decode';
import React, { useCallback, useEffect, useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { MdFileUpload, MdFilterList, MdSearch } from 'react-icons/md';
import { batch, useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { WarningToast } from '../../components/molecules/Toast';
import modal from '../../context/TriggerModalContext';
import history from '../../services/history';
import theme from '../../styles/theme';
import { downloadFile as fileDownload } from '../../utils/base64';

import useMovimentacao from '../../hooks/useMovimentacao';

import {
  isAdmin,
  isContratante,
  isContratanteNestle,
} from '../../utils/userRole';
import { hasChar } from '../../utils/validation';

import {
  MovimentacaoListaEnum,
  StatusListaAPIEnum,
  TipoListaEnum,
  TipoPerfilUsuarioEnum,
} from '../../enums';

import { Container } from './styles';

import FadeIn from '../../components/atoms/FadeIn';

import FilterExtendsLista from '../../components/organisms/FilterExtends';
import ImportarListas from '../../components/organisms/ImportarListas';
import ModalAcaoLista from '../../components/organisms/ModalAcaoLista';
import TabTableLista from '../../components/organisms/TabTableLista';

import { ModalEnviarListaRpa } from '../../components/molecules/PartsModalConsultaListas';

import LoadingSpinner from '../../components/molecules/LoadingSpinning';
import StatusList from '../../components/molecules/StatusList';
import { Creators as ListaActions } from '../../store/ducks/lista';
import { Creators as ModalidadeActions } from '../../store/ducks/modalidade';

function ConsultaListas() {
  const dispatch = useDispatch();

  const {
    patchListaEnvioRPA,
    postImportarLote,
    deleteLista,
    statusLists,
    getRelatorioLista,
    getArquivoOriginalLote,
  } = useSelector((state) => state.lista);
  const getListasRedux = useSelector((state) => state.lista.getListas);
  const logError = postImportarLote.logError || [
    {
      hasError: false,
      base64: null,
    },
  ];

  const { usuario } = useSelector((state) => state.auth);
  const { success, response } = useSelector((state) => state.modalidade);

  const [openFilterExtends, setOpenFilterExtends] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const [cancelFilterExtendsOpen, setCancelFilterExtendsOpen] = useState(false);

  // #region State para Modal para acao de lista
  const [openImportarLote, setOpenImportarLote] = useState(false);
  const [openFileLoading, setOpenFileLoading] = useState(false);
  const [isAcaoOpen, setIsAcaoOpen] = useState(false); // State para o Modal de ações de Lista
  const [acaoAtual, setAcaoAtual] = useState(0); // Define qual ação será executada no Modal File Import
  // #endregion
  const status = statusLists.response.actives
    .filter(({ id }) => id !== 0)
    .map(({ id }) => id);

  const { accessToken } = useSelector((state) => state.auth);

  const { IsAdm } = jwtDecode(accessToken);

  const oldFilterExtendsParams = {
    nomeLista: null,
    codigoContratante:
      usuario.role !== 'Adm' ? usuario.codigoContratante : null,
    nomeBeneficiario: null,
    cartaoBeneficiario: null,
    tipoLista: null,
    idTipoMovimentacao: null,
    codigoModalidade: null,
    codigoTermo: null,
    vencida: null,
    rn412: null,
    dataCriacaoDe: null,
    dataCriacaoAte: null,
    dataAtualizacaoDe: null,
    dataAtualizacaoAte: null,
    nomeArquivoMovimentacao: null,
    nomeGrupoContratante: isContratanteNestle(usuario)
      ? usuario.GrupoContratante
      : null,
  };
  const filterExtendsParams = {
    page_number: 0,
    page_size: 10,
    is_nestle_query: isContratanteNestle(usuario),
    movement_list_filter: {
      is_admin: usuario.role === 'Adm',
      status: status,
      list_name: null,
      beneficiary_name_or_number_card: null,
      type_list: null,
      type_action: null,
      contractor_code:
        usuario.role === 'Adm' || isContratanteNestle(usuario)
          ? null
          : usuario.codigoContratante,
      modality_code: null,
      term_code: null,
      expired: false,
      r_n412: false,
      file_name_movement: null,
      start_created_date: null,
      end_created_date: null,
      start_update_date: null,
      end_update_date: null,
      show_fake_list: IsAdm.toLowerCase() === 'true',
    },
  };
  const paginationTabParams = {
    pageNumber: 1,
    pageSize: 10,
  };

  const optionsButtonDropdown = [
    {
      onClickOption: () =>
        getAcaoLista(MovimentacaoListaEnum.returnIdForName.Lote),
      text: 'ARQUIVO - TXT',
    },
    {
      onClickOption: () =>
        getAcaoLista(MovimentacaoListaEnum.returnIdForName['Lote-csv']),
      text: 'ARQUIVO - CSV',
    },
  ];
  // #region Hooks
  const { handleFiles, setErrors, handleDeleteFiles } =
    useMovimentacao(usuario);

  const [oldFilterParams, setOldFilterParams] = useState(
    oldFilterExtendsParams
  );
  const [filterParams, setFilterParams] = useState(filterExtendsParams);
  const [paginationParams, setPaginationParams] = useState(paginationTabParams);
  const [listaAction, setListaAction] = useState({
    listas: [],
    tipoAcao: '',
  });

  const [relatoriosLoading, setRelatoriosLoading] = useState({
    resumido: false,
    detalhado: false,
  });
  const [reportsItems, setReportItems] = useState([]);
  const [isCheckedAllPages, setIsCheckedAllPages] = useState(false);

  const reportExtendsParams = {
    is_administrator: usuario.role === 'Adm',
    is_detailed: true,
    list_ids: [],
    movement_list_filter: null,
    is_nestle_query: isContratanteNestle(usuario),
  };
  const paginationRequest = produce(paginationParams, (draft) => {
    draft.pageNumber = paginationParams.pageNumber - 1;
    draft.pageSize = paginationParams.pageSize;
  });

  const [openModalSuccess, setOpenModalSuccess] = useState({
    success: false,
    message: '',
  });
  const [openModalCancelAction, setOpenModalCancelAction] = useState({
    warning: false,
    message: '',
    textHeader: '',
    onClickOk: null,
  });
  const [searchBoxActive, setSearchBoxActive] = useState(false);
  const [reportParams, setReportParams] = useState(reportExtendsParams);

  function cleanFilterParams() {
    setFilterParams(filterExtendsParams);
  }

  function handleData(data) {
    const boolPorTexto = {
      Sim: true,
      Não: false,
    };

    const contractorOrAdm =
      usuario.role === 'Adm' || isContratanteNestle(usuario)
        ? null
        : usuario.codigoContratante;

    const newFilterParams = produce(filterParams, (draft) => {
      draft.movement_list_filter.status = status;
      draft.movement_list_filter.list_name =
        inputValue === '' ? null : inputValue;
      draft.movement_list_filter.beneficiary_name_or_number_card =
        data.nomeBeneficiarioCartao ? data.nomeBeneficiarioCartao : null;

      draft.movement_list_filter.type_list =
        data.tipo === 'Selecione o tipo'
          ? null
          : TipoListaEnum.returnId[data.tipo];

      draft.movement_list_filter.type_action =
        data.movimentacao === 'Selecione a movimentação'
          ? null
          : MovimentacaoListaEnum.returnIdForNameFormatted[data.movimentacao];

      draft.movement_list_filter.contractor_code = data.codigoContratante
        ? data.codigoContratante
        : contractorOrAdm;

      draft.movement_list_filter.modality_code =
        data.modalidade === 'Selecione a modalidade' ? null : data.modalidade;

      draft.movement_list_filter.term_code =
        data.termo === 'Selecione o termo' ? null : data.termo;

      draft.movement_list_filter.expired =
        data.vencida === 'Todas' ? false : boolPorTexto[data.vencida];

      draft.movement_list_filter.r_n412 =
        data.rn412 === 'Todas' ? false : boolPorTexto[data.rn412];
      draft.movement_list_filter.file_name_movement =
        usuario.role === 'Adm' || isContratanteNestle(usuario)
          ? data.nomeArquivoMovimentacao
          : null;

      draft.movement_list_filter.start_created_date = data.dataCriacaoDe
        ? format(data.dataCriacaoDe, 'MM-dd-yyyy 00:00:00')
        : null;

      draft.movement_list_filter.end_created_date = data.dataCriacaoAte
        ? format(data.dataCriacaoAte, 'MM-dd-yyyy 23:59:59')
        : null;

      draft.movement_list_filter.start_update_date = data.dataAtualizacaoDe
        ? format(data.dataAtualizacaoDe, 'MM-dd-yyyy 00:00:00')
        : null;

      draft.movement_list_filter.end_update_date = data.dataAtualizacaoAte
        ? format(data.dataAtualizacaoAte, 'MM-dd-yyyy 23:59:59')
        : null;
    });

    const params = {
      ...newFilterParams,
      ...paginationRequest,
    };

    setFilterParams(newFilterParams);
    return params;
  }
  function handleCheckBoxAllPagesReport() {
    setReportItems([]);
    setIsCheckedAllPages(!isCheckedAllPages);
  }
  function handleSubmit(data) {
    const params = handleData(data);
    setSearchBoxActive(true);
    dispatch(ListaActions.postSearchListRequest(params));
    setCancelFilterExtendsOpen(false);
  }

  function handleModalidadesTermos() {
    if (isContratante(usuario.role))
      dispatch(
        ModalidadeActions.getModalidadesRequest({
          codigoContratante: oldFilterParams.codigoContratante,
          getInativos: true,
        })
      );
  }

  function handleFilterExtends() {
    setOpenFilterExtends(!openFilterExtends);
  }

  function handleInputChange(e) {
    setInputValue(e.target.value);
  }

  function handleInputKeyDown(e) {
    if (e.keyCode === 13) {
      // 'enter' was pressed
      if (status.length >= 1) {
        const newFilterParams = produce(filterParams, (draft) => {
          draft.movement_list_filter.status = status;
        });
        const params = {
          ...newFilterParams,
        };
        setPaginationParams(paginationTabParams);
        return dispatch(ListaActions.postSearchListRequest(params));
      }

      const totalStatus = [13, 9, 16, 12, 11, 7, 2, 10, 14, 4, 5];

      if (e.target.value === '') {
        const newFilterParams = produce(filterParams, (draft) => {
          draft.movement_list_filter.status = totalStatus;
          draft.movement_list_filter.list_name = null;
        });

        setFilterParams(newFilterParams);
        setSearchBoxActive(true);
        return dispatch(ListaActions.postSearchListRequest(newFilterParams));
      }

      const newFilterParams = produce(filterParams, (draft) => {
        draft.movement_list_filter.list_name = e.target.value;
      });
      const params = {
        ...newFilterParams,
      };
      dispatch(ListaActions.postSearchListRequest(params));
      setCancelFilterExtendsOpen(true);
      setSearchBoxActive(true);
      setFilterParams(newFilterParams);
    }
  }

  function handlePageChangeKeyDown(e) {
    const newFilterParams = produce(filterParams, (draft) => {
      draft.movement_list_filter.status = status;
    });
    if (e.keyCode === 13) {
      if (status.length < 1) {
        const params = {
          ...paginationRequest,
          ...filterParams,
        };
        return dispatch(ListaActions.postSearchListRequest(params));
      }
      const params = {
        ...newFilterParams,
        ...paginationRequest,
      };

      if (paginationParams.pageNumber !== '')
        dispatch(ListaActions.postSearchListRequest(params));
    }
  }

  function handleChangeTab(nameTab) {
    const nameTabCapitalize = `${nameTab
      .charAt(0)
      .toUpperCase()}${nameTab.slice(1)}`;
    const { pageNumber, pageSize } = getListasRedux.response[nameTabCapitalize];
    setPaginationParams((oldParams) => ({
      ...oldParams,
      pageNumber,
      pageSize,
    }));
  }

  function handleChangePage(paramsPag, tipoStatus) {
    const newPaginationParams = produce(paramsPag, (draft) => {
      draft.pageNumber = paramsPag.pageNumber - 1;
      draft.pageSize = paramsPag.pageSize;
    });

    if (status.length < 1) {
      const params = {
        ...filterParams,
        ...newPaginationParams,
      };

      return dispatch(ListaActions.postSearchListRequest(params));
    }

    const newFilterParams = produce(filterParams, (draft) => {
      draft.movement_list_filter.status = status;
    });

    const params = {
      ...newFilterParams,
      ...newPaginationParams,
    };

    return dispatch(ListaActions.postSearchListRequest(params));
  }

  function handleGetModalidadesByContratante(e, codigoContratante) {
    e.stopPropagation();
    if (e.keyCode === 13) e.preventDefault();

    if (
      codigoContratante &&
      oldFilterParams.codigoContratante !== codigoContratante
    ) {
      const newFilterParams = produce(oldFilterParams, (draft) => {
        draft.codigoContratante = codigoContratante;
      });

      setOldFilterParams(newFilterParams);
      if (isAdmin(usuario.role))
        dispatch(
          ModalidadeActions.getModalidadesRequest({
            codigoContratante: newFilterParams.codigoContratante,
            getInativos: true,
          })
        );
    }

    setCancelFilterExtendsOpen(true);
  }

  function handleConfirmAction(listas, tipoAcao, hasFake) {
    setListaAction({
      listas,
      tipoAcao,
    });

    const qtdListas = Array.isArray(listas) ? listas.length : 1;

    modal.warning(
      <ModalEnviarListaRpa.BodyEnviarListaRpa
        hasFake={hasFake}
        qtdListas={qtdListas}
      />,
      () => {},
      ({ closeModal }) => (
        <ModalEnviarListaRpa.FooterEnviarListaRpa
          closeModal={closeModal}
          onClickOk={() => {
            setAcaoLista(listas, tipoAcao);
            closeModal();
          }}
        />
      )
    );
  }

  function setAcaoLista(listas, tipoAcao) {
    return Array.isArray(listas)
      ? handleAcaoListas(listas, tipoAcao)
      : handleAcaoListaById(listas, tipoAcao);
  }

  function handleAcaoListas(listas, tipoAcao) {
    const TIPO_INATIVOS = 'Inativos';

    const listasPermitidas = listas.filter(
      (lista) =>
        lista.idStatusLista === 10 && lista.dcTipoAcao !== TIPO_INATIVOS
    );

    if (listasPermitidas.length > 0) {
      const params = listasPermitidas.map((l) => {
        return { idLista: l.idLista };
      });

      const actionLista = setListaActionToDispatch(tipoAcao, params);

      dispatch(actionLista);
    }
  }

  function handleAcaoListaById(listas, tipoAcao) {
    const params = [
      {
        idLista: listas,
      },
    ];
    const actionLista = setListaActionToDispatch(tipoAcao, params);
    dispatch(actionLista);
  }

  function setListaActionToDispatch(action, params) {
    const actions = {
      PendentedeProcessamento: ListaActions.patchListaEnvioRPARequest(
        params,
        true
      ),
      Cancelar: ListaActions.patchListaEnvioRPARequest(params, false),
    };
    return actions[action];
  }

  function getListas() {
    const params = {
      ...paginationParams,
      nomeGrupoContratante: isContratanteNestle(usuario)
        ? usuario.GrupoContratante
        : null,
    };

    dispatch(
      ListaActions.getListasRequest(params, StatusListaAPIEnum.returnNameForTab)
    );
  }

  function handleModalSuccess() {
    setOpenModalSuccess({
      success: !openModalSuccess.success,
    });

    if (patchListaEnvioRPA.success) {
      dispatch(ListaActions.patchListaEnvioRPARenew());
    }

    const newFilterParams = produce(filterParams, (draft) => {
      draft.movement_list_filter.status = status;
    });

    const params = {
      ...newFilterParams,
      ...paginationRequest,
    };

    dispatch(ListaActions.postSearchListRequest(params));
  }

  // #region Funções para Acao de Lista
  function toggleModalAcaoLista() {
    setIsAcaoOpen(!isAcaoOpen);
  }

  const toogleModalFileLoading = useCallback(() => {
    setOpenFileLoading(!openFileLoading);
  }, [openFileLoading]);

  function toogleModalImportar() {
    setOpenImportarLote(!openImportarLote);
  }

  const handleModalCancelAction = useCallback(
    (newFile) => {
      setOpenModalCancelAction({
        warning: !openModalCancelAction.warning,
        message:
          'Ao cancelar a importação de listas você perderá os dados não salvos. Deseja continuar?',
        textHeader: 'cancelar',
        onClickOk: () => {
          if (MovimentacaoListaEnum.returnIdForName['Lote-csv'] === acaoAtual) {
            handleDeleteFiles(newFile);
            dispatch(ListaActions.deleteListaCsv(postImportarLote.files));
          } else {
            handleDeleteFiles(newFile);
            if (newFile.length === postImportarLote.files.length) {
              dispatch(ListaActions.importarLoteLogErrorRenew());
            }
          }
        },
      });
    },
    [handleDeleteFiles, openModalCancelAction.warning]
  );

  const getAcaoLista = (acao) => {
    const acoes = {
      [MovimentacaoListaEnum.returnIdForName.Lote]: toogleModalImportar,
      [MovimentacaoListaEnum.returnIdForName['Lote-csv']]: toogleModalImportar,
      [MovimentacaoListaEnum.returnIdForName.Nestle]: toogleModalImportar,
      [MovimentacaoListaEnum.returnIdForName.Inclusao]: toggleModalAcaoLista,
      [MovimentacaoListaEnum.returnIdForName.Alteração]: toggleModalAcaoLista,
      [MovimentacaoListaEnum.returnIdForName.Exclusão]: toggleModalAcaoLista,
      [MovimentacaoListaEnum.returnIdForName.Transferencia]: () => {
        toggleModalAcaoLista();
        toogleModalImportar();
      },
    };
    setAcaoAtual(acao);
    return acoes[acao]();
  };

  // #region relatórios download

  function handleDropdownItemClick(item) {
    let tipoRelatorio;

    if (reportsItems.length === 0 && !isCheckedAllPages) {
      return toast.error(
        <WarningToast>
          Nenhuma lista selecionada para geração do relatório
        </WarningToast>
      );
    }
    if (item.includes('resumido')) {
      const filter = produce(filterParams, (draft) => {
        draft.movement_list_filter.status = status;
      });

      const params = produce(reportParams, (draft) => {
        draft.list_ids = isCheckedAllPages
          ? []
          : reportsItems.map((l) => l.idLista);
        draft.is_detailed = false;
        draft.movement_list_filter = isCheckedAllPages
          ? filter.movement_list_filter
          : null;
      });

      dispatch(
        ListaActions.postRelatorioResumidoNovoRequest(params, 'resumido')
      );
      setIsCheckedAllPages(false);
      tipoRelatorio = 'resumido';
    } else if (item.includes('detalhado')) {
      const filter = produce(filterParams, (draft) => {
        draft.movement_list_filter.status = status;
      });
      const params = produce(reportParams, (draft) => {
        draft.list_ids = isCheckedAllPages
          ? []
          : reportsItems.map((l) => l.idLista);
        draft.is_detailed = true;
        draft.movement_list_filter = isCheckedAllPages
          ? filter.movement_list_filter
          : null;
      });

      dispatch(
        ListaActions.postRelatorioDetalhadoNovoRequest(params, 'detalhado')
      );
      setIsCheckedAllPages(false);
      tipoRelatorio = 'detalhado';
    }

    const newLoading = produce(relatoriosLoading, (draft) => {
      draft[tipoRelatorio] = true;
    });

    setRelatoriosLoading(newLoading);
  }

  function downloadFileOriginLot(fileName) {
    dispatch(ListaActions.getDownloadArquivoLoteOriginal(fileName));
  }

  function downloadFile(base64, filename) {
    const temp = `data:application/vnd.ms-excel;base64,${encodeURIComponent(
      base64
    )}`;
    const download = document.createElement('a');
    download.href = temp;
    download.download = filename;
    document.body.appendChild(download);
    download.click();
    document.body.removeChild(download);
  }
  // #endregion
  useEffect(() => {
    if (!getArquivoOriginalLote.loading && getArquivoOriginalLote.success) {
      if (getArquivoOriginalLote.response.fileContents !== '') {
        const extension = {
          'text/plain': 'txt',
          'text/csv': 'csv',
        };

        fileDownload(
          getArquivoOriginalLote.response.fileContents,
          getArquivoOriginalLote.response.fileDownloadName,
          extension[getArquivoOriginalLote.response.contentType]
        );
      }
    }
  }, [getArquivoOriginalLote.loading, getArquivoOriginalLote.response]);

  useEffect(() => {
    if (!getRelatorioLista.loading && getRelatorioLista.success) {
      if (getRelatorioLista.response.fileContents !== '') {
        downloadFile(
          getRelatorioLista.response.fileContents,
          getRelatorioLista.response.fileDownloadName
        );
      }
    }

    if (!getRelatorioLista.loading) {
      setRelatoriosLoading({ resumido: false, detalhado: false });
    }
  }, [getRelatorioLista.loading, getRelatorioLista.response]);

  useEffect(() => {
    handleModalidadesTermos();
    batch(() => {
      dispatch(ListaActions.importarLoteRenew());
      dispatch(ListaActions.deleteListaRenew());
    });
  }, []);

  useEffect(() => {
    if (deleteLista.success) {
      if (postImportarLote.files.length > 0) {
        handleModalCancelAction();
        toogleModalFileLoading();
      } else {
        handleModalCancelAction();
        setOpenFileLoading(false);
      }
    }
    dispatch(ListaActions.deleteListaRenew());
  }, [deleteLista.success]);

  useEffect(() => {
    if (patchListaEnvioRPA.success) {
      setOpenModalSuccess({
        success: !openModalSuccess.success,
        message:
          listaAction.tipoAcao === 'Cancelar'
            ? 'Cancelamento de envio foi efetuado.'
            : 'Envio para o RPA com sucesso.',
      });
    }
  }, [patchListaEnvioRPA.success]);

  return (
    <Container>
      <FadeIn>
        <WrapperFlex justifyStart alignStart column>
          <WrapperFlex fullWidth justifySpaceBetween alignStart>
            <Title
              text="listas de movimentações"
              color={theme.titleGray}
              fontSize={38}
              marginBottom={8}
            />
            <WrapperFlex
              percentageWidth={30}
              justifyEnd
              alignCenter
              marginSides={10}
              flexWrap
              gap={10}
              marginRight={1}
            >
              <CanAccess
                checkRole={{
                  ContratanteAlteracao:
                    TipoPerfilUsuarioEnum.returnNameForName
                      .ContratanteAlteracao,
                }}
                userRole={usuario.role}
              >
                {!isContratanteNestle(usuario) ? (
                  <Dropdown
                    margin={0}
                    options={optionsButtonDropdown}
                    tipo="button"
                    height={40}
                    background={theme.greenDefault}
                    fontHeader="16px unimed_slabregular"
                  >
                    Importar Lote
                  </Dropdown>
                ) : (
                  <Button
                    tipo="secondary"
                    paddingTop={8}
                    paddingRight={8}
                    paddingBottom={8}
                    paddingLeft={8}
                    padding={8}
                    justifySpaceBetween
                    alignCenter
                    width={147}
                    font="16px unimed_slabregular"
                    onClick={() =>
                      getAcaoLista(
                        !isContratanteNestle(usuario)
                          ? MovimentacaoListaEnum.returnIdForName.Lote
                          : MovimentacaoListaEnum.returnIdForName.Nestle
                      )
                    }
                  >
                    <MdFileUpload color={theme.greenDefault} />
                    importar lote
                  </Button>
                )}

                {!isContratanteNestle(usuario) && (
                  <Button
                    tipo="primary"
                    paddingTop={10}
                    paddingRight={10}
                    paddingBottom={10}
                    paddingLeft={10}
                    justifySpaceBetween
                    alignCenter
                    width={124}
                    font="16px unimed_slabregular"
                    onClick={toggleModalAcaoLista}
                  >
                    <AiOutlinePlus color="#FFFF" />
                    nova lista
                  </Button>
                )}
              </CanAccess>
            </WrapperFlex>
          </WrapperFlex>
          <Breadcrumbs
            crumbs={[
              { path: 'novo' },
              { path: 'lista', onNavigate: () => history.push('/novo/lista') },
            ]}
          />
        </WrapperFlex>
        <StatusList />

        {status.length < 1 ? (
          <WrapperFlex fullWidth justifyStart alignStart row marginBottom={25}>
            <SearchBox
              onClick={handleFilterExtends}
              isPressed={openFilterExtends}
              placeholder="Pesquise por nome da lista"
              onChange={handleInputChange}
              value={inputValue}
              onKeyDown={handleInputKeyDown}
              cancelFilterExtendsOpen={cancelFilterExtendsOpen}
              onClearInputs={cleanFilterParams}
              IconFilter={MdFilterList}
              IconSearch={MdSearch}
            />
          </WrapperFlex>
        ) : (
          <Form onSubmit={handleSubmit}>
            <WrapperFlex
              fullWidth
              justifyStart
              alignStart
              row
              marginBottom={25}
            >
              <SearchBox
                onClick={handleFilterExtends}
                isPressed={openFilterExtends}
                placeholder="Pesquise por nome da lista"
                onChange={handleInputChange}
                value={inputValue}
                onKeyDown={handleInputKeyDown}
                cancelFilterExtendsOpen={cancelFilterExtendsOpen}
                onClearInputs={cleanFilterParams}
                IconFilter={MdFilterList}
                IconSearch={MdSearch}
              >
                <WrapperFlex justifyStart alignStart row flex marginBottom={70}>
                  <FilterExtendsLista
                    isGetModalidadesSuccess={success}
                    modalidades={response}
                    handleGetModalidadesByContratante={
                      handleGetModalidadesByContratante
                    }
                    setSearchBoxValue={setInputValue}
                    cleanFilterParams={cleanFilterParams}
                    showwFilterNomeArquivo
                  />
                </WrapperFlex>
              </SearchBox>
            </WrapperFlex>
          </Form>
        )}

        <WrapperFlex justifyStart alignCenter column>
          {status.length < 1 && !searchBoxActive ? (
            <Text
              size={20}
              bold
              text="Ao menos um status deve ser selecionado para iniciar a pesquisa"
            />
          ) : (
            <TabTableLista
              setPaginationParams={setPaginationParams}
              paginationParams={paginationParams}
              handlePageChangeKeyDown={handlePageChangeKeyDown}
              handleConfirmAction={handleConfirmAction}
              handleAcaoListas={handleAcaoListas}
              handleAcaoListaById={handleAcaoListaById}
              handleChangePage={handleChangePage}
              handleChangeTab={handleChangeTab}
              filterParams={filterParams}
              reportsItems={reportsItems}
              setReportItems={setReportItems}
              handleCheckBoxAllPagesReport={handleCheckBoxAllPagesReport}
              isCheckedAllPages={isCheckedAllPages}
              handleDropdownItemClick={handleDropdownItemClick}
              setIsCheckedAllPages={setIsCheckedAllPages}
              downloadFileOriginLot={downloadFileOriginLot}
            />
          )}
        </WrapperFlex>
        <LogsFileErrorStorage logs={logError}>
          <ImportarListas
            openFileImport={openImportarLote}
            openFileLoading={openFileLoading}
            onClickFileImport={toogleModalImportar}
            onClickFileLoading={toogleModalFileLoading}
            acaoAtual={acaoAtual}
            invalidCallback={setErrors(acaoAtual)}
            files={postImportarLote.files}
            handleFiles={(newFiles) =>
              handleFiles(acaoAtual, newFiles, () => {
                toogleModalImportar();
                toogleModalFileLoading();
              })
            }
            isSuccess={
              postImportarLote.success || postImportarLote.isPartialSuccess
            }
            handleCancel={(file) => {
              toogleModalFileLoading();
              handleModalCancelAction(file);
            }}
            setAfterLoadingCallback={
              isContratanteNestle(usuario)
                ? () => {
                    toogleModalFileLoading();
                    getListas();
                  }
                : (_) => _
            }
            loading={postImportarLote.loading}
          />
        </LogsFileErrorStorage>
        <Modal
          header={
            <WrapperFlex alignCenter column flex>
              <Text
                color="rgba(90,90,90,1)"
                font="normal normal 800 24px/43px unimed_slabbold"
                size={22}
                text="Relatórios!"
              />
            </WrapperFlex>
          }
          isOpen={getRelatorioLista.loading}
        >
          <WrapperFlex alignCenter column flex gap={20}>
            <Text center text="Relatório sendo gerado, Aguarde..." />
            <LoadingSpinner />
          </WrapperFlex>
        </Modal>
        <Modal
          tipo="warning"
          onClick={() => {
            handleModalCancelAction();
            setOpenFileLoading(false);
          }}
          isOpen={openModalCancelAction.warning}
          footer={
            <ModalCancelActionFooter
              onClick={() => {
                handleModalCancelAction();
                setOpenFileLoading(false);
              }}
              onClickOk={openModalCancelAction.onClickOk}
              isLoading={deleteLista.loading}
            />
          }
        >
          <Text
            center
            text={openModalCancelAction.message}
            font="300 14px work_sans"
            color={theme.titleGray}
            marginTop={25}
            marginSides={30}
            marginBottom={25}
          />
        </Modal>
        <Modal
          tipo="success"
          onClick={handleModalSuccess}
          isOpen={openModalSuccess.message}
          footer={
            <>
              <Button
                tipo="primary"
                marginBottom={30}
                display="block"
                width={100}
                font="16px unimed_slabregular"
                onClick={handleModalSuccess}
              >
                ok
              </Button>
            </>
          }
        >
          <Text
            center
            text={openModalSuccess.message}
            font="300 14px work_sans"
            color={theme.titleGray}
          />
        </Modal>
        <ModalAcaoLista
          isOpen={isAcaoOpen}
          onClick={toggleModalAcaoLista}
          handleClick={getAcaoLista}
        />
      </FadeIn>
    </Container>
  );
}

const ModalCancelActionFooter = ({ onClick, isLoading, onClickOk }) => {
  return (
    <>
      <Button
        tipo="secondary"
        onClick={onClick}
        marginRight={14}
        type="button"
        justifyCenter
        alignCenter
        width={121}
        disabled={isLoading}
        font="16px unimed_slabregular"
      >
        cancelar
      </Button>
      <Button
        tipo="primary"
        onClick={onClickOk}
        marginLeft={14}
        type="button"
        justifyCenter
        alignCenter
        width={121}
        disabled={isLoading}
        font="16px unimed_slabregular"
      >
        sim
      </Button>
    </>
  );
};

export default ConsultaListas;
